
export default {
  name: 'SplitSection',
  props: {
    blok: {
      type: Object,
      required: true
    }
  }
}
